// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("/home/utkarshrai/Downloads/sprocket-gsf-web/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import("/home/utkarshrai/Downloads/sprocket-gsf-web/.cache/data.json")

